module.exports = __webpack_public_path__ + "img/38.f6ec5c77.jpg";